module.exports = __webpack_public_path__ + "static/noises-dark-v3-3e67bed838cd933911fa64a76a43624f.png";